import styled from "styled-components";

export const List = styled.div`
  display: grid;
  grid-row-gap: 20px;
`;
